// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___2BF0k","open":"open___2F4Nl","search":"search___1tK0d"};